import React from 'react';

import s from "./Home.module.css"
import { Link } from 'react-router-dom';

const Home = () => {
    return (
        <div className={s.mainPageContainer}>
            <div className={s.mainContentContainer}>
                <h2>Юридические документы за пару кликов</h2>
                <p>
                    Онлайн-сервис генерации документов, который поможет быстро подготовить юридически грамотные бумаги. Сервис предназначен для всех: от физических лиц без юридического образования до предпринимателей и юристов, которым нужно сэкономить время. Просто ответьте на несколько вопросов — и получите готовый документ, соответствующий всем требованиям.
                </p>
                <h2 style={{textAlign: "center"}}>Преимущества сервиса</h2>
                <p>
                    {/*  */}
                    <div className={s.container}>
                        {/* Кружки */}
                        <div className={`${s.circle} ${s.circle1}`}>Удобство</div>
                        <div className={`${s.circle} ${s.circle2}`}>Скорость</div>
                        <div className={`${s.circle} ${s.circle3}`}>Доступ 24/7</div>
                        <div className={`${s.circle} ${s.circle4}`}>Персонализация</div>
                        <div className={`${s.circle} ${s.circle5}`}>Экономия</div>

                        {/* Вертикальные стрелки, каждая направлена строго сверху к своему кружку */}
                        <div className={`${s.arrow} ${s.arrow1}`}></div>
                        <div className={`${s.arrow} ${s.arrow2}`}></div>
                        <div className={`${s.arrow} ${s.arrow3}`}></div>
                        <div className={`${s.arrow} ${s.arrow4}`}></div>
                        <div className={`${s.arrow} ${s.arrow5}`}></div>
                    </div>
                    {/*  */}
                    <ul>
                        <li>Удобство: Интуитивно понятная анкета без сложных терминов – вам не нужны специальные знания.
                        </li>
                        <li>Скорость: Создание документа занимает всего несколько минут.
                        </li>
                        <li>Юридическая точность: Шаблоны разработаны юристами, учтены все необходимые требования закона.
                        </li>
                        <li>
                            Персонализация: Документ формируется под вашу ситуацию на основе введённых данных.
                        </li>
                        <li>
                            Доступность: Сервис работает онлайн 24/7 и доступен с компьютера или смартфона.
                        </li>
                    </ul>
                </p>
                <Link to="/contracts/receipt_of_financial_funds"><h3>Расписка о займе🔗</h3></Link>
                <p>Расписка о займе – это документ, подтверждающий передачу денег в долг. Правильно составленная расписка защитит интересы обеих сторон и послужит доказательством в спорных ситуациях. Наш сервис поможет оформить расписку с указанием всех важных деталей: данных заемщика и займодавца, суммы займа, сроков возврата и условий, – чтобы документ имел юридическую силу.</p>
                <h3 className={s.link}>Претензия🔗</h3>
                <p>Претензия – официальное письмо-требование, направляемое контрагенту для урегулирования спора до суда. Грамотно оформленная претензия повышает шанс решить проблему мирно или служит основанием для дальнейших юридических действий. С помощью нашего генератора вы быстро составите претензию, включив в неё все необходимые детали: сведения о сторонах, описание проблемы, требования к ее решению и сроки. Документ будет оформлен в корректной деловой форме, что придаст ему юридическую значимость.</p>
                <h3>Как это работает</h3>
                <p>
                    <ol>
                        <li>Заполните форму: ответьте на несколько простых вопросов о вашей ситуации.</li>
                        <li>Получите документ: нажмите «Сгенерировать», и сервис мгновенно подготовит для вас документ по введённым данным.</li>
                        <li>Сохраните результат: скачайте готовую расписку или претензию и воспользуйтесь ею для своих целей.</li>
                    </ol>
                </p>
            </div>
        </div>
    );
};

export default Home;